import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import * as LS from 'local-storage'
import { courseStoryPath } from '../utils/course-paths'

const propTypes = {
  location: PropTypes.shape({
    query: PropTypes.shape({
      course_id: PropTypes.string,
      preview_token: PropTypes.string,
    }).isRequired,
  }).isRequired,
}

function queryParam(value) {
  if (Array.isArray(value)) return value[0]
  return value
}

// Entry point for the admin "Preview Course" flow.
//
// LearningHubCoursesController#preview_course redirects here with the
// per-course preview token in the query string. We do three things:
//
//   1. Stash the (course_id, preview_token) pair in localStorage so the
//      preview-aware player components can pick it back up on every
//      subsequent client-side navigation (chapters → block → next block …).
//
//   2. Replace the URL with /learning-hub/course-preview/course/:id so the
//      browser back/forward stack actually has meaningful entries, and so
//      the React-Router params drive the player pages directly instead of
//      a hidden query-string handoff.
//
//   3. Render a brief fallback while step 2 happens.
//
// If the token or course id is missing or malformed, show a static error
// message — no point dumping the admin into a broken player state.
function CoursePreviewShell({ location: { query } }) {
  const courseId = Number(queryParam(query.course_id))
  const previewToken = queryParam(query.preview_token)
  const hasValidEntry = !!(courseId && previewToken)

  useEffect(() => {
    if (!hasValidEntry) return
    LS.setPreviewCourseId(courseId)
    LS.setPreviewToken(previewToken)
    browserHistory.replace(courseStoryPath(courseId, { isPreview: true }))
  }, [hasValidEntry, courseId, previewToken])

  if (!hasValidEntry) {
    return <p>Invalid or missing course preview link.</p>
  }

  return <p>Loading course preview…</p>
}

CoursePreviewShell.propTypes = propTypes

export default CoursePreviewShell
